import { getClient } from '@/lib/restClient';
import {
  DayOfWeek,
  PeriodString,
} from '@/pages/menu-managements/business-hours/service';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuHourService } from '@/services/BrandMenuHour/MenuManagementBrandMenuHourService';
export type MenuManagementBrandMenuHourUpdateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  day_of_week_periods: {
    day_of_week: DayOfWeek;
    periods: PeriodString[];
  }[];
};

export const useMenuManagementUpdateBrandMenuHour = async (
  id: string,
  params: MenuManagementBrandMenuHourUpdateParams
): Promise<void> => {
  const menuManagementBrandMenuHourService =
    new MenuManagementBrandMenuHourService(getClient());

  return menuManagementBrandMenuHourService.update(id, params);
};
